import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IHeaderProps {
  name?: string;
  favorite?: React.ReactNode;
  call?: React.ReactNode;
  chat?: React.ReactNode;
}

export function Header({ name, favorite, call, chat }: IHeaderProps): React.JSX.Element {
  return (
    <div className={styles['container']} data-testid="FullscreenGalleryHeader">
      {name && (
        <div className={styles['name']}>
          <Body1 fontWeight="700">ЖК «{name}»</Body1>
        </div>
      )}
      <div className={styles['button-group']}>
        {call}
        {chat}
        {favorite}
      </div>
    </div>
  );
}
